<template>
    <v-app>

        <v-container fluid>
            <v-row>
                <v-col cols="12">

                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>

                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                                Salary Component List
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <!-- Top Controls -->
                                <v-row class="py-2">

                                    <!-- Search -->
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="pl-2"
                                            clearable
                                        ></v-text-field>
                                    </v-col>

                                    <!-- Export Buttons -->
                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <!-- Add Button -->
                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn
                                                v-if="$insertAccess($route.fullPath)"
                                                @click="openAddItem"
                                                color="primary"
                                                variant="tonal"
                                                prepend-icon="mdi mdi-plus"
                                                rounded="xl"
                                            >
                                                Add Salary Component
                                            </v-btn>
                                        </div>
                                    </v-col>

                                </v-row>

                                <!-- Table -->
                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    density="compact"
                                    :hover="true"
                                >

                                    <!-- Serial -->
                                    <template v-slot:item.index="{ index }">
                                        {{ index + 1 }}
                                    </template>

                                    <!-- Percentage -->
                                    <template v-slot:item.is_percentage="{ item }">
                                        <v-chip :color="item.is_percentage ? 'success' : 'red'" size="small">
                                            {{ item.is_percentage ? 'Yes' : 'No' }}
                                        </v-chip>
                                    </template>

                                    <!-- Status -->
                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color="item.status ? 'success' : 'red'" size="small">
                                            {{ item.status ? 'Active' : 'Inactive' }}
                                        </v-chip>
                                    </template>

                                    <!-- Created By -->
                                    <template v-slot:item.created_by="{ item }">
                                        {{ item.created_by?.full_name ?? '--' }}
                                    </template>

                                    <!-- Actions -->
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon
                                            class="me-2 edit-button"
                                            color="primary"
                                            @click="editItem(item)"
                                            v-if="$updateAccess($route.fullPath)"
                                        >
                                            mdi-pencil-outline
                                        </v-icon>
                                    </template>

                                </v-data-table>

                            </v-expansion-panel-text>

                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>
export default {
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        data: {},

        headers: [
            { title: "#SL", key: "index", align: "center", sortable: false, width: "7%" },
            { title: "Name", key: "name", align: "left" },
            { title: "Type", key: "type", align: "left" },
            { title: "Default Value", key: "default_value", align: "left" },
            { title: "Percentage", key: "is_percentage", align: "center" },
            { title: "Status", key: "status", align: "center" },
            { title: "Actions", key: "actions", align: "center", sortable: false },
        ],
    }),

    created() {
        // if (this.$store.getters.salaryComponentList.length == 0) {
            this.loading = true;
            this.$store.dispatch('salaryComponentList').then(() => {
                this.loading = false;
            });
        // }
    },

    computed: {
        getSchema() {
            return this.$store.getters.salaryComponentList;
        },
    },

    methods: {

        /* Add Item */
        openAddItem() {
            this.$router.push({ name: "salary-component",});
        },

        /* Edit Item */
        editItem(item) {
            this.$store.commit('editingsalaryComponent', item);
            this.$router.push({
                name: "salary-component",
                query: { id: item.id },
            });
        },

        /* Export PDF */
        exportToPDF() {
            let serial = 1;
            const columns = ["#SL", "Name", "Type", "Default", "Status"];
            const rows = this.getSchema.map(i => [
                serial++,
                i.name,
                i.type,
                i.default_value,
                i.status ? "Active" : "Inactive",
            ]);
            this.$exportTableToPDF(columns, rows, "Salary Component List", "salary_components_" + this.$fileDate());
        },

        /* Export Excel */
        exportToExcel() {
            let excel = [["#SL", "Name", "Type", "Default", "Status"]];
            let sl = 1;

            this.getSchema.forEach(i => {
                excel.push([sl++, i.name, i.type, i.default_value, i.status ? "Active" : "Inactive"]);
            });

            this.$exportTableToExcel(excel, "salary_components_" + this.$fileDate());
        },

        /* Export CSV */
        exportToCSV() {
            let csv = [["#SL", "Name", "Type", "Default", "Status"]];
            let sl = 1;

            this.getSchema.forEach(i => {
                csv.push([sl++, i.name, i.type, i.default_value, i.status ? "Active" : "Inactive"]);
            });

            this.$exportTableToCSV(csv, "salary_components_" + this.$fileDate());
        },
    },
};
</script>

<style scoped>
.panel-header {
    font-weight: bold;
}
</style>
